/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

      if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
         e.preventDefault();
        if ($(e.target).parents("[data-ajax-cart-trigger]").length > 0) {
              $('.logout_modal').removeClass('is-visible');
           
              window.PXUTheme.jsAjaxCart.showDrawer();
        
              return false;
        }
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

      if (window.PXUTheme.jsCart) {
        window.PXUTheme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');
    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
        accordion();
        // giftWrapping();
      }
    }, function() {
      $el.removeClass('show-mini-cart');

    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    cartheight()
    $('body').addClass('overflow-hidden');
    lockDrawerScroll();
    accordion();
    // giftWrapping();
  
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('body').removeClass('overflow-hidden');
    unlockDrawerScroll();
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('[data-add-to-cart-trigger]');
    this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');

    if (this.recipientForm) {
      this.recipientForm.classList.remove('recipient-form--has-errors');
    }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;
      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');
        },
        success: function (product) {

          var btn = $addToCartBtn[0];
          var textSpan = btn.querySelector('span.text');
          var origText = $addToCartBtn.data('label') || $addToCartBtn.data('originalText') || textSpan.textContent.trim();
          textSpan.textContent = 'ADDED TO CART';

          window.setTimeout(function() {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            textSpan.textContent = origText;
            btn.style.removeProperty('background-color');
            btn.style.removeProperty('color');
            window.PXUTheme.jsAjaxCart.showDrawer();
            window.PXUTheme.jsAjaxCart.updateView();
          }, 300);

          if (window.PXUTheme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: XMLHttpRequest => {
          const response = eval('(' + XMLHttpRequest.responseText + ')');

          $('.warning').remove();

          let cartWarning;

          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
          }

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
        const ajax_subtotal = $(html.content).find(".ajax-cart-totla-inner-main");
        const Ajax_item_count = $(html.content).find(".total_cart_item_count");
        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $(".ajax-cart-totla-inner-main").replaceWith(ajax_subtotal);
        $(".cart_ajax_header_inner h3 span").replaceWith(Ajax_item_count);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
        // Force compositor repaint of position:fixed footer on mobile Safari/Chrome
        var footer = document.querySelector('.cart-draawer-footer');
        if (footer) { footer.style.willChange = 'transform'; requestAnimationFrame(function() { footer.style.willChange = ''; }); }

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;


// Prevent page scroll bleed when cart drawer is open.
// Blocks wheel/touch events on drawer background; clamps Zone 1 at boundaries.

function lockDrawerScroll() {
  const drawer = document.getElementById('theme-ajax-cart');
  if (!drawer) return;

  drawer._wheelHandler = function(e) {
    const cartList = drawer.querySelector('.cart_detalis');
    if (cartList && cartList.contains(e.target)) {
      // Inside Zone 1 — allow scroll but prevent chaining at boundaries
      const atTop = cartList.scrollTop === 0;
      const atBottom = cartList.scrollTop + cartList.clientHeight >= cartList.scrollHeight - 1;
      if ((atTop && e.deltaY < 0) || (atBottom && e.deltaY > 0)) {
        e.preventDefault();
      }
    } else {
      // Outside Zone 1 (overlay, footer, subtotal) — block entirely
      e.preventDefault();
    }
  };

  drawer._touchMoveHandler = function(e) {
    const cartList = drawer.querySelector('.cart_detalis');
    if (cartList && cartList.contains(e.target)) {
      // Inside Zone 1 — allow touch scroll (let CSS overflow handle it)
      return;
    }
    // Outside Zone 1 — block
    e.preventDefault();
  };

  drawer.addEventListener('wheel', drawer._wheelHandler, { passive: false });
  drawer.addEventListener('touchmove', drawer._touchMoveHandler, { passive: false });
}

function unlockDrawerScroll() {
  const drawer = document.getElementById('theme-ajax-cart');
  if (!drawer) return;
  if (drawer._wheelHandler) {
    drawer.removeEventListener('wheel', drawer._wheelHandler);
    drawer._wheelHandler = null;
  }
  if (drawer._touchMoveHandler) {
    drawer.removeEventListener('touchmove', drawer._touchMoveHandler);
    drawer._touchMoveHandler = null;
  }
}


function accordion(){
     $(".cart-note-shipping .cart-expand-button").off('click').on('click', function(){
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(".cart_detalis").removeClass("active");
        $(this).siblings(".accordion-contant").slideUp(300);
        // if(window.innerWidth < 575){
          $(this).next("textarea").slideUp(300);
        // }
      } else {
      $(".cart-note-shipping .cart-expand-button").removeClass("active");
        $(this).addClass("active");
        $(".cart_detalis").addClass("active");
        $(".accordion-contant").slideUp(300);
        $(this).siblings(".accordion-contant").slideDown(300);
        // if(window.innerWidth < 575){
          $(this).next("textarea").slideDown(300);
        // }
      }
    });
}


var top_bar = $('.top-bar').innerHeight();
var header = $('.header').innerHeight();
var plus = top_bar + header
//   $('.theme-ajax-cart').css('top', `${plus}px`)

// function height(e) {
//   var moblie_header = $('.mobile-header').innerHeight();
//     if($(window).width() < 798){
//       $('.theme-ajax-cart').css('top', `${moblie_header}px`)
//     }
//   }
//   height();


//   $(window).resize(function(){
//     height();
//   });

// sticky header
$( window ).on( "scroll", function() {
cartheight()
});

function cartheight() {
  
   	var windowpos = $(window).scrollTop();
  	if (windowpos >= 100) {
      const headerHeight = $('.header-sticky-wrapper.is-sticky').outerHeight();
      // $('.theme-ajax-cart').css('top', `${headerHeight}px`);
      $('#theme-ajax-cart.is-drawer').css('position', 'fixed');
      const footerheight = $('.cart-draawer-footer').height();
      const height = $(window).height();
      const desktopBuffer = 170;
      $('.ajax-cart--drawer .cart_detalis').css('max-height', `calc(${height - desktopBuffer - (headerHeight + footerheight)}px)`);
	}
  else{
    var top_bar = $('.top-bar').innerHeight();
    if(top_bar == undefined){
      top_bar = 0
    }
    if($(window).width() > 798){ var header = $('.header').innerHeight();}
    else{var header = $('.mobile-header').innerHeight();}
    var plus = top_bar + header;
    const footerheight = $('.cart-draawer-footer').height();
    const height = $(window).height();
    const buffer = $(window).width() > 798 ? 170 : 50;
    $('.ajax-cart--drawer .cart_detalis').css('max-height', `calc(${height - buffer - (plus + footerheight)}px)`);
  }
}
$(document).ready(function(){
  cartheight()
})

